module.exports = __webpack_public_path__ + "static/recruitment_service-98a3194e8f64ebfe3034df95492368ea.svg";